import { Checkbox } from "primereact/checkbox";
import { useMapURLParams } from "../../../../../../hooks/map/useMapParams";
import { useMapSlice } from "../../../../../../stateManagement/hooks/useMapSlice";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { MapListCheckboxFilter } from "../types";
import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { classNames } from "primereact/utils";
import { patchFilterListCheckboxState } from "./filterListCheckboxFunctions";
import SmallLoader from "../../../../../loaders/SmallLoader";

type FilterListCheckboxProps = {
    filterConfig: MapListCheckboxFilter
}

const captionFilter = (caption: string, searchValue: string) => caption?.toLowerCase().includes(searchValue.toLowerCase())

export default function FilterListCheckbox({ filterConfig }: FilterListCheckboxProps) {
    const dispatchMap = useMapDispatch()
    const { canBeIgnored, canIncludeNull, fieldName, hasSearch } = filterConfig ?? {}
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };;
    const mapState = useMapSlice(mapName)
    const { mapFiltersState }: any = mapState ?? {};
    const filterState = mapFiltersState?.[fieldName]
    const { isIgnored, includeNull, values, searchValue } = filterState ?? {}
    const ignoreInputId = `ignore-${fieldName}`
    const nullInputId = `null-${fieldName}`

    const listCheckboxContainerClassNames = classNames({
        "list-checkbox": true,
        "with-search-container": hasSearch,
        "filter-ignore": isIgnored
    })

    const showNullInput =
        canIncludeNull &&
        (!hasSearch || captionFilter('Не указан', searchValue));

    const visibleValues = hasSearch
        ? values?.filter((valueObj: any) => captionFilter(valueObj.caption, searchValue))
        : values;

    const IsIgnoredValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={ignoreInputId}
                name={ignoreInputId}
                onChange={(event: any) => patchFilterListCheckboxState(mapName, fieldName, { isIgnored: event.checked }, dispatchMap)}
                checked={isIgnored}
            />
            <label htmlFor={ignoreInputId} className="ms-2">Не учитывать</label>
        </div>
    )

    const IncludeNullValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={nullInputId}
                name={nullInputId}
                onChange={(event: any) => patchFilterListCheckboxState(mapName, fieldName, { includeNull: event.checked }, dispatchMap)}
                checked={includeNull}
            />
            <label htmlFor={nullInputId} className="ms-2">Не указан</label>
        </div>
    )

    return (
        <div className="filter-list-checkbox">
            {hasSearch && canBeIgnored && <IsIgnoredValueCheckbox />}
            {hasSearch &&
                <input
                    onChange={(e: any) => patchFilterListCheckboxState(mapName, fieldName, { searchValue: e.target.value }, dispatchMap)}
                    value={searchValue}
                    className="list-checkbox-search"
                />
            }
            <div className={listCheckboxContainerClassNames}>
                {hasSearch && showNullInput && <IncludeNullValueCheckbox />}
                {visibleValues
                    ?
                    <>
                        {visibleValues?.map((valueObject: any) => {
                            const { caption, value, checked, color } = valueObject ?? {}
                            const valueInputId = `${value}`
                            return (
                                <div className="map-hint-filters-checkbox-div" style={{ '--checkbox-color': color } as React.CSSProperties}>
                                    <Checkbox
                                        inputId={valueInputId}
                                        name={valueInputId}
                                        onChange={(event: any) => patchFilterListCheckboxState(mapName, fieldName, { toggleValue: { value, checked: event.checked } }, dispatchMap)}
                                        checked={checked}
                                    />
                                    <label htmlFor={valueInputId} className="ms-2">{caption}</label>
                                </div>
                            )
                        })}
                        {!hasSearch && showNullInput && <IncludeNullValueCheckbox />}
                        {!hasSearch && canBeIgnored && <IsIgnoredValueCheckbox />}
                    </>
                    :
                    <div className="map-hint-filters-checkbox-div">
                        <SmallLoader />
                    </div>
                }
                {visibleValues.length === 0 && !showNullInput &&
                    <div className="map-hint-filters-checkbox-div">
                        <label className="no-results">Нет результатов</label>
                    </div>
                }
            </div>
        </div>
    )
}
